let audioCtx = null;
let unlocked = false;
let lastSoundAt = 0;

function getAudioContext() {
    if (audioCtx) return audioCtx;
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return null;
    audioCtx = new Ctx();
    return audioCtx;
}

export function unlockNotificationSound() {
    if (unlocked) return;
    const ctx = getAudioContext();
    if (!ctx) return;
    if (ctx.state === "suspended") {
        ctx.resume().catch(() => {});
    }
    unlocked = true;
}

export function playNotificationSound() {
    if (document.visibilityState === "hidden") return;

    const nowMs = Date.now();
    if (nowMs - lastSoundAt < 800) return;
    lastSoundAt = nowMs;

    try {
        const ctx = getAudioContext();
        if (!ctx) return;
        if (ctx.state === "suspended") {
            ctx.resume().catch(() => {});
        }

        const now = ctx.currentTime;
        const playTone = (frequency, startOffset, duration) => {
            const osc = ctx.createOscillator();
            const gain = ctx.createGain();
            osc.type = "sine";
            osc.frequency.value = frequency;
            gain.gain.setValueAtTime(0.0001, now + startOffset);
            gain.gain.exponentialRampToValueAtTime(0.18, now + startOffset + 0.02);
            gain.gain.exponentialRampToValueAtTime(0.0001, now + startOffset + duration);
            osc.connect(gain);
            gain.connect(ctx.destination);
            osc.start(now + startOffset);
            osc.stop(now + startOffset + duration + 0.02);
        };

        playTone(880, 0, 0.12);
        playTone(1175, 0.14, 0.16);
    } catch (_) {
        // ignore
    }
}

export function notifyInAppSound() {
    playNotificationSound();
}

export function withInAppSound(handler) {
    return (...args) => {
        notifyInAppSound();
        return handler?.(...args);
    };
}

export function initNotificationSound() {
    const unlock = () => {
        unlockNotificationSound();
        window.removeEventListener("touchstart", unlock, true);
        window.removeEventListener("click", unlock, true);
    };

    window.addEventListener("touchstart", unlock, true);
    window.addEventListener("click", unlock, true);
    window.addEventListener("wrPushReceived", () => playNotificationSound());
}
